import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default function isPhoneNumber(num: string): boolean {
  if (/[a-zA-Z]/.test(num)) {
    return false;
  }
  const phoneNumber = parsePhoneNumberFromString(num, 'US'); // Default region is 'US' 
  if (!phoneNumber) return false;
  const isValidUSorCanada = (phoneNumber.country === 'US' || phoneNumber.country === 'CA') && phoneNumber.isValid();
  return isValidUSorCanada;
}
